// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.3.2@css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-breadcrumb[data-v-5d88b13f]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
